/**
 * Energy Precisions brand colors
 * Green: Primary accent, CTAs, highlights
 * Blue-black: Headers, dark sections, premium feel
 */
export const colors = {
  green: '#00E676',
  greenDark: '#00C85F',
  greenLight: 'rgba(0, 230, 118, 0.15)',
  blueBlack: '#0a0e17',
  blueBlackLight: '#0d1b2a',
  blueNavy: '#1a4d7a',
  blueNavyDark: '#0d3a5a',
  white: '#ffffff',
  offWhite: '#f8fafc',
  gray100: '#f1f5f9',
  gray200: '#e2e8f0',
  gray400: '#94a3b8',
  gray600: '#475569',
  gray800: '#1e293b',
};
